import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthSelectors } from '../../store';
import { switchMap, first } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class UrlInterceptor implements HttpInterceptor {
    constructor(
        private authSelector: AuthSelectors,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = req.url;
        let newUrl: string | null;
        newUrl = /^\[api]/i.test(url) ? url.replace(/^\[api]/i, environment.apiUrl + '/api') :
            /^\[legacyurl]/i.test(url) ? url.replace(/^\[legacyurl]/i, environment.legacyUrl + '/api') : null;
        if (!newUrl) {
            return next.handle(req);
        }
        // add userid and officeid to url
        return this.authSelector.userIds$.pipe(
            first(),
            switchMap(ids => {
                if (ids.userId > 0 && ids.officeId > 0) {
                    newUrl = newUrl
                        .replace(/\[userid]/gi, ids.userId.toString())
                        .replace(/\[username]/gi, ids.userName.toString())
                        .replace(/\[officeid]/gi, ids.officeId.toString());
                }
                const newReq = req.clone({url: newUrl});
                return next.handle(newReq);
            })
        );
    }

}
